import React, { useEffect, useState } from 'react';
import './dataTableDollarCharges.scss';
import { DataGrid } from '@mui/x-data-grid';
import { dollarchargesColumns } from '../../data/dataSource';
import { Link } from 'react-router-dom';
import { collection, deleteDoc, doc, getDoc, onSnapshot, orderBy,query } from "firebase/firestore";
import { db } from '../../firebase'



const DataTable = () => {

  const [ data, setData ] = useState([])

  const [ isLoading, setIsLoading ] = useState(true)


  const Spinner = () => {
    return(
      <div className='spinner-container'>
          <div className='loading-spinner'></div>
      </div>
    )
  }

  useEffect(() => {
   
    
//LISTEN REAL TIME

    const collectionRef = collection(db, "dollarCharges")

    const queryCharges = query(collectionRef)

    const unsub = onSnapshot(queryCharges, (snapShot) => {

      let list = [];

      snapShot.docs.forEach((doc) => {

        list.push({ id: doc.id, ...doc.data()})

      })

      setData(list)

      setIsLoading(false)

    }, 
      (error) => {
        console.log(error)
      }
    );

    return () => {
      unsub();
    }

//END LISTEN REAL TIME    

  },[])


    



  const handleDelete = async (id) => {

    try{

      await deleteDoc(doc(db, "charges", id));
      setData(data.filter((item) => item.id !== id))

    }catch(err){

      console.log(err)

    }
   
  }

  const actionColumn = [

    { field: 'action', headerName: 'Action', width: 140, 
    
            renderCell:(params) => {
                return(
                    <div className='cellAction'>
                       {/* <Link to={`/dollarCharges/${params.row.id}`} style={{textDecoration:"none"}}>
                          <div className="viewbutton">View</div>
                       </Link> */}
                        <Link to={`/dollarCharges/edit/${params.row.id}`} style={{textDecoration:"none"}}>
                        <div className="viewbutton">Edit Dollar Charge</div>
                     </Link>
                       
                       {/* <div className='deletebutton' onClick={() => handleDelete(params.row.id)}>Delete</div> */}
                    </div>
                )
            }
    }
      
  ]  

  return (
    <div className="datatable">
      <div className='datatableTitle'>
        Dollar Charges
        <div></div>
        {/* <Link to="/dollarCharges/new"  style={{textDecoration:"none"}}>
          <div className='link'>
            Add New Dollar Charges
          </div>
        </Link> */}
      </div>
      {isLoading ? <Spinner/> : 
        <DataGrid
            className="chargesTableGrid"
            rows={data}
            columns={dollarchargesColumns.concat(actionColumn)}
            pageSize={5}
            rowsPerPageOptions={[10]}
            checkboxSelection
            sx={{
              '& .bold-header .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 'bold',
                fontSize:18
              },
            }}
        />
    }
    </div>
  )
}

export default DataTable